import { VueConstructor } from 'vue/types/umd'
import moment from 'moment'
import { TeamMember } from '@/models'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { Utils } from '@/utils'
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/utils/constants'

export default {
  install(Vue: VueConstructor) {
    Vue.filter('formatDate', function formatDate(value: string) {
      if (value) {
        return moment(value).format(DATE_FORMAT)
      }
      return ''
    })

    Vue.filter('formatDateTime', function formatDateTime(value: string) {
      if (value) {
        return moment(String(value)).format(DATE_TIME_FORMAT)
      }
      return ''
    })

    Vue.filter('formatTeamCompleteName', function formatTeamCompleteName(teamMember: TeamMember) {
      if (teamMember.firstName && teamMember.lastName) {
        return `${teamMember.firstName} ${teamMember.lastName}`
      }
      return ''
    })

    Vue.filter('daysLeftDateFromToday', function formatTeamCompleteName(date: string) {
      if (!date) {
        return 0
      }
      return Utils.daysFromToday(date)
    })

    Vue.filter('formatGetCvValueName', function formatDateTime(value: string, type: string) {
      const typeName = CvValueUtils.getCvValueName(value, type)
      return typeName
    })
  }
}
